function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo, Children, isValidElement, cloneElement, useEffect, useState } from 'react';
import { ClickAwayListener, Grow, MenuList, Paper, Popper, useTheme } from '@material-ui/core';
import { _MenuRows } from "./styles";

/**
 * @see https://www.w3.org/TR/wai-aria-practices/examples/menu-button/menu-button-links.html
 */
export function Menu(props) {
  var theme = useTheme();

  // ready when anchorRef prop becomes defined
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    ready = _useState2[0],
    setReady = _useState2[1];

  // when element Menu is anchored to finishes rendering, set ready to true
  useEffect(function () {
    if (props.anchorRef === null) return;
    if (props.anchorRef.current !== null) setReady(true);
  }, [props.anchorRef]);
  var handleClose = function handleClose(event) {
    var anchorRef = props.anchorRef,
      setOpen = props.setOpen;

    // if triggered by "click away" and element clicked was the anchor element, stay open
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    if (setOpen) {
      setOpen(false);
    }
  };
  var children = useMemo(function () {
    return Children.map(props.children, function (child) {
      if ( /*#__PURE__*/isValidElement(child)) {
        return /*#__PURE__*/cloneElement(child, {
          depth: 0,
          collapsible: props.collapsible,
          multiple: props.multiple
        });
      }
      return child;
    });
  }, [props.children]);
  var placement = useMemo(function () {
    if (props.placement === 'top' && props.fullWidth) return 'top-start';
    if (props.placement === 'bottom' && props.fullWidth) return 'bottom-start';
    return props.placement;
  }, [props.placement, props.fullWidth]);
  if (!ready) return null;
  return /*#__PURE__*/React.createElement(Popper, {
    open: props.open,
    anchorEl: props.anchorRef.current,
    role: undefined,
    transition: true,
    placement: placement,
    disablePortal: true,
    style: {
      minWidth: props.fullWidth ? '100%' : 'max-content',
      zIndex: theme.zIndex.tooltip - 1
    },
    modifiers: {
      // Allows the popper to be used in the case that an ancestor is a scroll pane.
      preventOverflow: {
        enabled: false
      },
      hide: {
        enabled: false
      }
    }
  }, function (_ref) {
    var TransitionProps = _ref.TransitionProps;
    return /*#__PURE__*/React.createElement(Grow, _extends({}, TransitionProps, {
      style: {
        transformOrigin: 'center top'
      }
    }), /*#__PURE__*/React.createElement(Paper, {
      style: {
        overflowY: 'auto',
        maxHeight: props.maxHeight
      }
    }, /*#__PURE__*/React.createElement(ClickAwayListener, {
      onClickAway: handleClose
    }, /*#__PURE__*/React.createElement(MenuList, {
      id: props.id,
      "aria-labelledby": props['aria-labelledby'],
      disablePadding: true,
      autoFocusItem: props.open
    }, /*#__PURE__*/React.createElement(_MenuRows, null, children)))));
  });
}
Menu.defaultProps = {
  collapsible: false,
  multiple: false,
  open: false,
  anchorRef: null,
  fullWidth: false,
  children: null,
  placement: 'bottom',
  maxHeight: 'auto'
};